import { Confirm } from "@/components/Confirm";
import List from "@/components/list";
const Table = args => {
  const { listeners, parent } = args;

  const RCSelectionChange = listeners["selection-change"] || function () { };
  const DeletePerson = listeners["delete-person"] || function () { };
  // 删除人员
  async function deletePerson(person) {
    try {
      await Confirm("确定删除该用户吗?", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      // DeletePerson(person)
      parent.persons.splice(parent.persons.indexOf(person), 1);
      parent.getCurrentPersons();
      parent.$emit('changePersons', parent.persons)
    } catch (error) {
      if (error === "cancel") return;
    }
  }

  const Deal = ({ props: { vo } }) => {
    const person = vo.row;
    const dealConf = [
      [
        "icon-delete",
        "删除",
        () => {
          deletePerson(person);
        }
      ]
    ];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip width="50%" content={item[1]} placement="top">
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
        {
          type: "selection",
          label: "main"
        },
        {
          label: "姓名",
          prop: "userName"
        },
        {
          label: "原工作单位",
          prop: "deptName"
        },
        {
          label: "原单位及职务",
          prop: "unitPosition"
        },
        {
          label: "操作",
          width: '200',
          render: vo => <Deal vo={vo} />
        }
      ];
  return (
    <List
      {...args}
      empty-text="请点击右上角【添加调出用户】"
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
